import { Grid } from "@mui/material";
import React from "react";
import Recipe from "../../components/internal/recipe";
import riceImag from "../../assets/recipes/arroz.jpg";
import shrimpImag from "../../assets/recipes/Arroz_camarones.jpg";
import ricemilkImag from "../../assets/recipes/arroz_leche.jpg";
import cantonesImag from "../../assets/recipes/arroz_cantones.jpg";
import chikenImag from "../../assets/recipes/arroz_pollo.jpg";
import cornImag from "../../assets/recipes/elote_asado.jpg";
import tamalImag from "../../assets/recipes/Tamal_elote.jpg";
import chorreadaImag from "../../assets/recipes/chorreadas.jpg";
import masamorraImag from "../../assets/recipes/mazamorra.jpg";
import meriendaImag from "../../assets/recipes/elotes.jpg";


interface RecipeCreate {
  title: string;
  image: string;
  recipeDescription: string;
  steps: string;
}

const RecipesList: React.FC = React.memo(() => {
  const recipes: RecipeCreate[] = [
    {
      title: "Arroz",
      image: riceImag,
      recipeDescription: "Arroz cocido",
      steps: "Agrega una taza de arroz",
    },
    {
      title: "Arroz con camarones",
      image: shrimpImag,
      recipeDescription: "Arroz cocido",
      steps:
        "1. Agrega una taza de arroz 2. Agrega medio kg de camarones 3. Ingredientes: cebolla, ajo, culantro, salsa inglesa",
    },
    {
      title: "Arroz con leche",
      image: ricemilkImag,
      recipeDescription: "Delicioso postre",
      steps:
        "1. Agrega una taza de arroz 2. Agrega una botella de leche 3. Ingredientes: coco, numar, clavo de olor, azúcar",
    },
    {
      title: "Arroz cantonés",
      image: cantonesImag,
      recipeDescription: "Arroz cocido",
      steps:
        "1. Agrega una taza de arroz 2. Agrega diferentes carnes: jamón, cerdo, pollo 3. Ingredientes: Cebolla, ajo, salsa inglesa, ",
    },
    {
      title: "Arroz con pollo",
      image: chikenImag,
      recipeDescription: "Delicioso almuerzo",
      steps:
        "1. Agrega una taza de arroz 2.Una pechuga de pollo 3.Ingredientes: Cebolla, culantro, lizano",
    },
    {
      title: "Elote asado",
      image: cornImag,
      recipeDescription: "Delicioso postre",
      steps:
        "1. Prepara los elotes y los coloca 10 minutos sobre el fuego 2.Coloca mantequilla y queso al gusto",
    },
    {
      title: "Chorreadas",
      image: chorreadaImag,
      recipeDescription: "Delicioso postre",
      steps:
        "1. Raspar los elotes 2. licuar con la leche, polvo de hornear, NUMAR CLÁSICA, sal y azúcar. 3. Calentar el sartén.",
    },
    {
      title: "Tamal de elote",
      image: tamalImag,
      recipeDescription: "Delicioso postre",
      steps:
        "1. Derretir la margarina en el microondas por 20 segundos.2. Licuar el maíz , maicena, azúcar, leche, harina, polvo de hornear.3 .Agregue grasa en aerosol a un recipiente rectangular mediano.4 .Agregue la mezcla al molde y lleve al horno a 350 F por aprox 45 minutos.5 .Verifique que esta cocido cuando los bordes se despeguen y el cuchillo salga limpio.",
    },
    {
      title: "Masamorra",
      image: masamorraImag,
      recipeDescription: "Delicioso postre",
      steps:
        "1. Colocar el maíz en remojo la noche anterior a su preparación 2. Al día siguiente hervir durante dos horas aproximadamente en agua y/o la leche con la canela el bicarbonato, la esencia de vainilla y el azúcar.3. Retirar la mazamorra, cuando los granos de maíz estén tiernos. ",
    },
    {
      title: "Merienda",
      image: meriendaImag,
      recipeDescription: "Delicioso postre",
      steps:
        "1. Coloca los elotes en agua y sal 2. Deja hervir durante 20 minutos",
    },
  ];
  // Función que maneja el clic de cada receta
  const handleRecipeClick = (
    recipe: RecipeCreate,
    event: React.MouseEvent
  ) => {
    event.stopPropagation(); // eliminar la propagación del evento
    console.log("Detalles de la receta:", JSON.stringify(recipe, null, 2));
  };
  return (
    <Grid container spacing={2}>
      {recipes.map((recipe) => (
        <Grid
          item
          xs={12}
          sm={6}
          lg={4}
          key={recipe.title}
          onClick={(event) => handleRecipeClick(recipe, event)}
          
        >
          <Recipe
            title={recipe.title}
            recipeDescription={recipe.recipeDescription}
            image={recipe.image}
            steps={recipe.steps}
          />
        </Grid>
      ))}
    </Grid>
  );
});
export default RecipesList;
